import { useIndicatorStore } from '../context/indicator';

/**
 * Indicator用Hook
 */
export const useIndicator = () => useIndicatorStore((selector) => selector);
